import { DocumentFile, DocumentsData, UserData } from "./common";

export interface DocumentsPageProps {
	showEmployeeCard?: boolean;
}

/** Maximum number of documents that can be processed for AI embeddings concurrently */
export const MAX_CONCURRENT_EMBEDDING_TASKS = 5;

export interface DocumentFileRow extends DocumentFile {
	handleSelectEdit: (document: DocumentFile) => void;
	handleSelectDelete: (document: DocumentFile) => void;
	handleViewDocument: (document: DocumentFile) => Promise<void>;
	handleToggleAiRetrieval?: (document: DocumentFile, newValue: boolean) => Promise<void>;
	userData: UserData;
	isCompanyDocumentPage?: boolean;
	/** Whether the document is currently being processed for AI embeddings */
	isProcessing?: boolean;
	/** Whether the concurrent embedding task limit has been reached */
	isEmbeddingLimitReached?: boolean;
	/** Current embedding processing progress (0-100) */
	embeddingProgress?: number;
}

export type DocumentTableRow = DocumentFile | FolderRow | TotalSizeRow | DownloadAllMyFilesRow;

export interface FolderRow {
	id: string;
	name: string;
	type: string;
	toggleFolderState: (id: string) => void;
	isOpen: boolean;
}

export interface TotalSizeRow {
	id: string;
	type: string;
	userId?: string;
	totalSize: number;
	name?: string;
	companyMaxSpace?: number;
}

export interface DownloadAllMyFilesRow {
	id: string;
	type: string;
	name: string;
	userId: string;
}

export interface DocumentVisibility {
	value: string;
	label: string;
}

export interface DocumentModalProps {
	document?: DocumentFile | null;
	show: boolean;
	onClose: () => void;
	userData?: UserData;
}

export interface EditDocumentModalProps extends DocumentModalProps {
	onEdit?: (
		id: string,
		fileName: string,
		vis: DocumentVisibility[],
		tags: string[],
		allowAiRetrieval?: boolean
	) => void;
	/** Whether the document is currently being processed for AI embeddings */
	isProcessing?: boolean;
	/** Whether the concurrent embedding task limit has been reached */
	isEmbeddingLimitReached?: boolean;
}

export interface UploadDocumentModalProps extends DocumentModalProps {
	documents: DocumentsData;
	setDocuments: (documents: DocumentsData) => void;
}

export interface DeleteDocumentModalProps extends DocumentModalProps {
	onDelete: () => void;
}

export interface ScanWarningModalProps {
	show: boolean;
	onClose: () => void;
}
